export default function LoadingMoreArticles({ loading = false, style = {}, color = 'black' }) {

  const styles = {
    text: {
      fontSize: "1rem",
      fontWeight: 400,
      letterSpacing: "0.5px",
      color
    },
    dot: {
      display: "inline-block",
      marginLeft: 2,
      animation: "pulse 1s infinite ease-in-out",
    },
  };


  return (
    <div style={style}>
      {/* one-off CSS for the pulse animation */}
      <style>{`
        @keyframes pulse {
          0%, 80%, 100% { opacity: 0 }
          40% { opacity: 1 }
        }
        .dot:nth-child(1) { animation-delay: 0s !important;  }
        .dot:nth-child(2) { animation-delay: .2s !important; }
        .dot:nth-child(3) { animation-delay: .4s !important; }
      `}</style>
      <span style={styles.text}>
        Loading more articles
        <span className="dot" style={styles.dot}>•</span>
        <span className="dot" style={styles.dot}>•</span>
        <span className="dot" style={styles.dot}>•</span>
      </span>
    </div>
  );
}
